import { Controller } from "@hotwired/stimulus"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    if (this.editor) return

    ClassicEditor
      .create(this.inputTarget, {
        toolbar: [
          "heading",
          "|",
          "bold", "italic", "underline",
          "|",
          "link",
          "bulletedList", "numberedList",
          "|",
          "undo", "redo"
        ]
      })
      .then(editor => {
        this.editor = editor
      })
  }

  disconnect() {
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  }
}
